module.exports = new __parcel__URL__("exit_room_door.876c5dff.png").toString();